import type { ArrivalStepKind } from '@/shared/api';

export interface GuideCopy {
  name: string;
  /** Mit Artikel und passendem Verb — „Die Anfahrhilfe konnte …“, „Die Parkmöglichkeiten konnten …“. */
  loadFailed: string;
  noun: string;
  /** Was am Objekt über die Apartments gilt. */
  objectHint: string;
  add: string;
  create: string;
  newTitle: string;
  editTitle: string;
  deleteTitle: string;
  emptyTitle: string;
  emptyText: string;
  count: (count: number) => string;
  example: { titleDe: string; bodyDe: string; titleEn: string; bodyEn: string };
}

/**
 * Anfahrt und Parkmöglichkeiten teilen den Editor, aber nicht die Worte: ein Parkhaus ist kein
 * „Schritt“, und ein Beispieltext für den Hinterhof führt beim Parkhinweis in die Irre.
 */
export const GUIDE_COPY: Record<ArrivalStepKind, GuideCopy> = {
  Arrival: {
    name: 'Anfahrhilfe',
    loadFailed: 'Die Anfahrhilfe konnte nicht geladen werden',
    noun: 'Schritt',
    objectHint:
      'Jeder Gast in jedem Apartment sieht diese Fassung; einzelne Schritte lassen sich im Apartment überschreiben.',
    add: 'Schritt hinzufügen',
    create: 'Schritt anlegen',
    newTitle: 'Neuer Schritt',
    editTitle: 'Schritt bearbeiten',
    deleteTitle: 'Schritt löschen?',
    emptyTitle: 'Noch keine Schritte',
    emptyText:
      'Der Gast steht mit dem Koffer vor der Tür — ein Schritt pro Handgriff ist besser als ein Absatz.',
    count: (count) => `${count} ${count === 1 ? 'Schritt' : 'Schritte'}`,
    example: {
      titleDe: 'Zum Hinterhof',
      bodyDe: 'Durch die Toreinfahrt links, dann Treppenhaus B.',
      titleEn: 'To the courtyard',
      bodyEn: 'Through the gateway on the left, then staircase B.',
    },
  },
  ParkingAlternatives: {
    name: 'Parkmöglichkeiten',
    loadFailed: 'Die Parkmöglichkeiten konnten nicht geladen werden',
    noun: 'Alternative',
    objectHint: 'Jeder Gast in jedem Apartment dieses Objekts sieht diese Hinweise.',
    add: 'Alternative hinzufügen',
    create: 'Alternative anlegen',
    newTitle: 'Neue Alternative',
    editTitle: 'Alternative bearbeiten',
    deleteTitle: 'Alternative löschen?',
    emptyTitle: 'Noch keine Alternativen',
    emptyText:
      'Ein Parkhaus, eine Anwohnerzone, eine Seitenstraße — mit Gehweg-Minuten und Preis, damit der Gast entscheiden kann.',
    count: (count) => `${count} ${count === 1 ? 'Alternative' : 'Alternativen'}`,
    example: {
      titleDe: 'Parkhaus am Römerplatz',
      bodyDe:
        'Sechs Gehminuten über die Innbrücke. Rund um die Uhr offen, Tagesticket am Automaten.',
      titleEn: 'Car park at Römerplatz',
      bodyEn:
        'Six minutes on foot across the Inn bridge. Open around the clock, day ticket at the machine.',
    },
  },
};
